export enum EventTargetAudience {
  /**************************
   *
   * General target audience
   *
   **************************/
  ACADEMICS = 'ACADEMICS',
  CITIZENS_GENERAL_PUBLIC = 'CITIZENS_GENERAL_PUBLIC',
  COUNSELLORS = 'COUNSELLORS',
  ESTABLISHED_ENTREPRENEURS_PRACTITIONERS = 'ESTABLISHED_ENTREPRENEURS_PRACTITIONERS',
  FEMALE_ENTREPRENEURS = 'FEMALE_ENTREPRENEURS',
  MEMBERS_OF_BUSINESS_SUPPORT_ORGANISATIONS = 'MEMBERS_OF_BUSINESS_SUPPORT_ORGANISATIONS',
  MEMBERS_OF_YOUTH_BUSINESS_ASSOCIATIONS = 'MEMBERS_OF_YOUTH_BUSINESS_ASSOCIATIONS',
  NEW_ENTREPRENEURS = 'NEW_ENTREPRENEURS',
  POLICY_MAKERS_CIVIL_SERVANTS = 'POLICY_MAKERS_CIVIL_SERVANTS',
  POTENTIAL_ENTREPRENEURS = 'POTENTIAL_ENTREPRENEURS',
  STUDENTS = 'STUDENTS',
  VENTURE_CAPITALISTS_BANKERS_PROVIDERS_OF_FINANCE = 'VENTURE_CAPITALISTS_BANKERS_PROVIDERS_OF_FINANCE',
  /**************************
   *
   * EU Entrepreneurship Day for students target audience
   *
   **************************/
  PRIMARY_SCHOOL = 'PRIMARY_SCHOOL',
  LOWER_SECONDARY_SCHOOL = 'LOWER_SECONDARY_SCHOOL',
  UPPER_SECONDARY_SCHOOL = 'UPPER_SECONDARY_SCHOOL',
  VOCATIONAL_EDUCATION = 'VOCATIONAL_EDUCATION',
  HIGHER_EDUCATION = 'HIGHER_EDUCATION',
  OTHER = 'OTHER',
}
